import React, { useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Loadersspinners from "./Loaders/LoadersSpinners";
import { Outlet, useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { userlog } from "../features/auth";
import { useNavigate } from "react-router-dom";
import { Baseurl } from "../../src/constants/env";
import Button from "react-bootstrap/Button";
import logo from '../styles/images/logo.svg'
import Searchbar from "./searchbar/Searchbar";
import { setuserdata, setuserid } from "../features/auth";
import Loader from "./common/spinner/Loader";


function SharedLayout() {
  const location = useLocation()
  const [loading, setLoading] = useState(false);
  const { userlogedin } = useSelector((state) => state.auth);
  const { totalcartitem } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [category , setCategory] =  useState([])
const {spinner} = useSelector((state)=>state.spin) 
      const getCategory = async () =>{
       let result = await axios(`${Baseurl}/category`)
       setCategory(result?.data?.data)
      }

  async function logout() {
    setLoading(true);
    await axios
      .get(`${Baseurl}/logout`, { withCredentials: true })
      .then(async (resp) => {
        localStorage.removeItem('token')
        localStorage.removeItem('id')
        localStorage.removeItem('userdata') 
        localStorage.removeItem('cart')
        dispatch(userlog(false));
        dispatch(setuserdata(true)) 
        dispatch(setuserid(null))
        setLoading(false);
        await navigate("/login", { replace: true });
        //console.log(resp);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  const [showCategory, setShowCategory] = useState(false);
  const categoryRef = useRef(null);

  const handleMouseEnter = () => setShowCategory(true);
  const handleMouseLeaveOuter = (e) => {
      try{
        if (categoryRef?.current && e.relatedTarget !== null && e.relatedTarget !== undefined && !categoryRef?.current?.contains(e.relatedTarget)) {
          setShowCategory(false);
      }
      }catch (error){
        console.log(error.message);
      }
  };
  const handleMouseLeaveCategory = () => {
      setShowCategory(false);
    };

    const handleSearch = async (id) => {
      console.log(id,'handleSearch');
      await navigate(`/Shop?category=${id}`);
   }

    useEffect(() => {
      getCategory()
    },[])

  return (
    <div>

      <header className="bg-white fixed-top"> 
      <div className="">
        <Container className="d-flex pt-2 ">
          <h4 onClick={() => navigate('/') }><img height={80} src="/images/logo.png"/></h4>
          <div className=" d-flex w-100">

            
           <Searchbar />



            {userlogedin ? (
              <div className="d-flex justify-content-end header-account-menu"> 
                {/* <NavLink to="/" style={{textDecoration: "none",padding: "7px",
                  }}>
                  Home
                </NavLink> */}
                <NavLink
                  to="cart"
                  style={{
                    textDecoration: "none",
                    padding: "7px",
                  }}
                >

<i class="bi bi-cart2"></i>
                  Cart <span className="text-theme fw-bold">{totalcartitem}</span>
                </NavLink>
                <NavLink
                  to="/Profile/userorders"
                  style={{
                    textDecoration: "none",
                    padding: "7px",
                  }}
                >
                  <i class="bi bi-receipt"></i>
                  Orders
                </NavLink>
                <NavLink
                  to="/Profile"
                  style={{
                    textDecoration: "none",
                    padding: "7px",
                  }}
                >
                  <i class="bi bi-person"></i>
                  Profile
                </NavLink>
                <Button
                  style={{
                    textDecoration: "none",
                    marginRight: "15px",
                    borderRadius: "8px", backgroundColor:'transparent',
                    border:'none',color:'#ccc', fontSize:'13px',
                  }}
                  onClick={logout}
                >
                   <i class="bi bi-key"></i>
                  Logout
                </Button>{" "}
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-end header-account-menu">
               <NavLink 
                  to="login"
                  style={{
                    textDecoration: "none", padding: "7px"
                  }}
                >
                  <i class="bi bi-key"></i>
                  Login
                </NavLink>

                 <NavLink
                  style={{ textDecoration: "none", padding: "7px" }}
                  to="register"
                >
                  <i class="bi bi-journal-arrow-up"></i>

                  Register
                </NavLink> 
              </div>
            )}
          </div>
        </Container>
      </div>
      <div>
        {loading ? (
          <div
            className="col-md-12 text-center text-white"
            style={{ marginTop: "220px" }}
          >
          </div>
        ) : (
          <div>
              <div className='container pt-2 pb-2'>
              <div className='row'>
              {/* <div className='col-xs-12 d-xs-block'> <span><img className='w-25' src='/ok' alt="failed"/></span></div> */}
                  <div className='col-sm-12 col-md-9 d-flex align-items-center'>
                  <div className='col-md-3 col-sm-6'>
                   <div className="btn btn-primary-theme me-3"
                 onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeaveOuter}> <i class="bi bi-list me-2"></i>
 Browse Categories <span className='ms-md-p-1'> </span> </div>
                <div className= {`category-drop-down  ${showCategory ? 'position-absolute w-25' : 'd-none'}`}
                 ref={categoryRef}
                 onMouseLeave={handleMouseLeaveCategory} >
                  {
                         category?.map((item,index) => (
                           <div key={index} className="text-start  drop-categories">
                           <span className="pe-2"><img style={{width:'20px', height:'20px'}} src={`${Baseurl}/view/imageupload/${item.img}`} /></span> 
                           <button onClick={() => handleSearch(item._id) } > {item?.name} </button> </div>
                         ))
                        }

                {/* <div className=" text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Bakery Line</div>
          
                <div className="text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Bevarage Line</div>
          
                <div className=" text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Blenders</div>
          
                <div className=" text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Coffee Line</div>
          
                <div className="text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Cooking Line</div>
          
                <div className=" text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Cold Line</div>
          
                <div className="text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Dishwashers</div>
          
                <div className=" text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                <button> Ovens Line</button>
               </div>
          
                <div className=" text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Food Processing Line</div>
          
                <div className=" text-start ">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Laundary Line</div>
          
                <div className=" text-start  d-none:hover">
                <span className="pe-2"><i class="bi bi-cake-fill"></i></span> 
                Clearance Items</div> */}
              </div>
          
                   </div>
                   <span className='fs-6 ms-3' style={location.pathname === "/" ? {  } : {}}>{location.pathname === "/" ? <span className="text-danger"> HOME </span> : <NavLink to="/" className='text-dark' style={{textDecoration: 'none'}}>HOME</NavLink> }</span>
                   <span className='fs-6 ms-3' style={location.pathname === "/Shop" ? {  } : {}}>{location.pathname === "/Shop" ? <span className="text-danger"> SHOP </span>  : <NavLink to="/Shop" className='text-dark' style={{textDecoration: 'none'}}>SHOP</NavLink> }</span>
                   <span className='fs-6 ms-3' style={location.pathname === "/brand" ? {  } : {}}>{location.pathname === "/brand" ? <span className="text-danger"> SHOP BY BRAND </span> : <NavLink to="/brand" className='text-dark' style={{textDecoration: 'none'}}>SHOP BY BRAND</NavLink> }</span>
                   {/* <span className='fs-6 ps-3'>2025 DEALS</span> */}
                  </div>
                  <div className='col-sm-5 col-md-3 d-none d-md-block'>
                  <div className='pt-3 d-flex justify-content-md-end'>
                  <span className='fs-6 ps-4'>Follow Us</span>
                   <span className='fs-6 ps-3'><i class="bi bi-facebook"></i></span>
                   <span className='fs-6 ps-2'><i class="bi bi-instagram"></i></span>
                   <span className='fs-6 ps-2'><i class="bi bi-youtube"></i></span>
                  </div>
                  </div>
              </div>
              </div>
         
          </div>
        )}
      </div>
      </header>
     <Outlet />
    </div>
  );
}

export default SharedLayout;
